import moment from 'moment'

import 'moment/locale/de'
import 'moment/locale/nl'
import 'moment/locale/fr'
import 'moment/locale/hu'
import 'moment/locale/sv'

import 'moment-timezone'

moment.locale('en')

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
